
import Footer from '../../footer'
import { useNavigate, useParams } from 'react-router-dom'
import StudentInfoBoxWithData from '../studentGrid/studentinfoboxwithdata'

import CheklistForProfile from './aplicationprofilesublist/checklistforprofile'
import MainEssayForProfile from './aplicationprofilesublist/mainessayforprofile'
import SuplementalEssayForProfile from './aplicationprofilesublist/suplementalessayforprofile'
import AditionalEssayForProfile from './aplicationprofilesublist/additionalinfoforprofile'
import SeniorBragSheetForProfile from './aplicationprofilesublist/seniorbragsheetforprofile'
import Activities from './aplicationprofilesublist/activities'

import { useRef,useState } from 'react'
import { useReactToPrint } from 'react-to-print'
import { logopcp } from '../../imagepath'
// import InstructorSidebar from '../sidebar'
// import { InstructorHeader } from '../header'

const AdminStudentAplicationProfile = () => {
  const [mobileMenu, setMobileMenu] = useState(false)
  const navigate = useNavigate()
  let { slug } = useParams()
  // console.log("slug : ", slug)

  const componentRef = useRef()
  // const handlePrint = useReactToPrint({
  //   content: () => componentRef.current
  // })
   const handlePrint = useReactToPrint({
     content: () => {
       removeBorderClasses()
       return componentRef.current
     },
     onAfterPrint: () => {
       restoreBorderClasses()
     }
   })

   const removeBorderClasses = () => {
    const elements = document.querySelectorAll('.border.border-3.border-primary');
    const transcriptDiv = document.getElementById('transcript_div_pdf');
    const pdfLogo = document.getElementById('pdf_logo');
    
    if (transcriptDiv) {
      transcriptDiv.classList.add('pdf_transcript_div');
      transcriptDiv.classList.remove('transcript_div');
    }
  
    if (pdfLogo) {
      pdfLogo.style.display = 'block';
    }
  
    elements.forEach((element) => {
      element.classList.add('border-hidden');
      element.classList.remove('border', 'border-3', 'border-primary');
    });
  }
  
  const restoreBorderClasses = () => {
    const elements = document.querySelectorAll('.border-hidden');
    const transcriptDiv = document.getElementById('transcript_div_pdf');
    const pdfLogo = document.getElementById('pdf_logo');
    
    if (transcriptDiv) {
      transcriptDiv.classList.remove('pdf_transcript_div');
      transcriptDiv.classList.add('transcript_div');
    }
  
    if (pdfLogo) {
      pdfLogo.style.display = 'none';
    }
  
    elements.forEach((element) => {
      element.classList.add('border', 'border-3', 'border-primary');
      element.classList.remove('border-hidden');
    });
  }
  

  return (
    <>
      <div className='main-wrapper'>
        <section className='course-content'>
          <div className='container-fluid w-80'>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <button
              onClick={() => navigate(-1)}
              className="btn btn-black btn-sm"
            >
              {"<< Back"}
            </button>
            <h3>Application Profile</h3>
            <button
              onClick={handlePrint}
              className="btn btn-info-light next_btn"
              style={{ backgroundColor: "blue", color: "white" }}
            >
              Print Page
            </button>
          </div>
            <div className='card wish-card' ref={componentRef}>
              <div className='card-header'>
                <StudentInfoBoxWithData slug={slug} taskshow={false} />
                <img
                  src={logopcp}
                  className='img-fluid pdf_logo'
                  id='pdf_logo'
                  alt='Logo'
                  style={{ display: 'none' }}
                />
              </div>
              <div className='page-break'>
                <CheklistForProfile slug={slug} />
              </div>
              <span className='border border-3 border-primary'></span>
              <div className='page-break'>
                <MainEssayForProfile slug={slug} />
              </div>
              <span className='border border-3 border-primary'></span>
              <div className='page-break'>
                <SuplementalEssayForProfile slug={slug} />
              </div>
              <span className='border border-3 border-primary'></span>
              <div className='page-break'>
                <Activities slug={slug} show={false} />
              </div>
              <span className='border border-3 border-primary'></span>
              <div className='page-break'>
                <AditionalEssayForProfile slug={slug} />
              </div>
              <span className='border border-3 border-primary'></span>
              <div className='page-break'>
                <SeniorBragSheetForProfile slug={slug} />
              </div>
            </div>
          </div>
        </section>

        {/* <Footer /> */}
      </div>
    </>
  )
}

export default AdminStudentAplicationProfile
